<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <!--<th>Niche</th>-->
                                        <th>Version</th>
                                        <th>CCompleted on</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <td>1</td>
                                        <!--<td>General</td>-->
                                        <td>2.0</td>
                                        <td>04/01/2017</td>
                                        <td>
                                            <i class="material-icons">remove_red_eye</i>
                                            <i class="material-icons">share</i>
                                            <i class="material-icons">file_download</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <!--<td>General</td>-->
                                        <td>3.0</td>
                                        <td>04/02/2017</td>
                                        <td>
                                            <i class="material-icons">remove_red_eye</i>
                                            <i class="material-icons">share</i>
                                            <i class="material-icons">file_download</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <!--<td>Sports</td>-->
                                        <td>2.0</td>
                                        <td>04/02/2017</td>
                                        <td>
                                            <i class="material-icons">remove_red_eye</i>
                                            <i class="material-icons">share</i>
                                            <i class="material-icons">file_download</i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
